// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/images/downAccrodianArrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interview-preparation {
    background-color: rgba(15, 1, 37, 1);
    color: #fff;
    min-height: 100vh;
    padding: 40px 100px 50px 50px;
}

.interview-preparation .interview-mode-header {
    margin-bottom: 30px;
    display: unset;
    border-bottom: none;
    background-color: transparent;
}

.interview-preparation .header-wrap .logo {
    max-width: 100px;
    display: block;
    margin-bottom: 5px;
}

.interview-preparation .interview-details {
    margin-top: 5px;
}

.interview-preparation .header-wrap .title {
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    text-align: left;
    font-family: "Inter", sans-serif;
}

.interview-preparation .interview-details .caller-details {
    font-size: 18px;
    font-weight: 400;
    line-height: 34px;
    font-family: "Inter", sans-serif;
    padding-bottom: 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    display: flex;
}

.interview-preparation .caller-details span {
    font-weight: 600;
}

.interview-preparation .caller-details .dot {
    display: block;
}

.interview-preparation .top-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0px;
}

.interview-preparation .status {
    font-size: 24px;
    font-weight: 600;
    line-height: 60px;
    color: #38bbf4;
    font-family: "Inter", sans-serif;
    color: #38bbf4;
    /* margin-bottom: 39px; */
}

.interview-preparation .warning {
    color: #ffb800;
}

.interview-preparation .error {
    color: #ef3f3f;
}

.interview-preparation .errorBg {
    background: #f842421f !important;
}

.interview-preparation .start-interview-button {
    background-color: #06efc5;
    color: #000;
    font-size: 18px;
    font-weight: 800;
    line-height: 13.33px;
    padding: 18px 60px;
    border: none;
    cursor: pointer;
    font-family: "Inter", sans-serif;
    gap: 10px;
}

.interview-preparation .disableButton {
    background-color: #271b3b;
    color: white;
}

.interview-preparation .filterInvert {
    filter: invert(1);
}

.interview-preparation .start-interview-button img {
    width: 20px;
    height: 20px;
}

.interview-preparation .bottom-content {
    display: flex;
    gap: 15px;
}

.interview-preparation .check-box {
    background-color: rgba(6, 239, 197, 0.11);
    padding: 32px 30px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
}

.interview-preparation .check-box .box-content-wrap .box-title {
    font-weight: 600;
    font-size: 18px;
    line-height: 19px;
    font-family: "Inter", sans-serif;
}

.interview-preparation .check-box .box-content-wrap .box-sub-title {
    font-weight: 400;
    font-size: 18px;
    line-height: 37px;
    padding: 16px 0px 10px;
    font-family: "Inter", sans-serif;
}

.interview-preparation .check-box .box-content-wrap .box-description {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    font-family: "Inter", sans-serif;
}

/* .interview-preparation .check-box .icon-check img {
    width: 14px;
    height: 14px;
} */

.interview-preparation .right-content .top-row {
    display: flex;
    gap: 15px;
}

.interview-preparation .right-content .bottom-row {
    display: flex;
    gap: 15px;
    margin-top: 15px;
}

.bottom-btn-wrap {
    display: none;
}

.interview-preparation .mobile-accrodians {
    display: none;
}

@media (max-width: 1650px) {
    .interview-preparation {
        padding: 30px 100px 30px;
    }

    .interview-preparation .check-box {
        padding: 15px 30px;
    }

    .caller-card-wrap .left-img-wrap .caller-img {
        width: 400px;
    }

    .caller-card-wrap .left-img-wrap .bottom-icon-wrap .bottom-title {
        line-height: 30px;
        font-size: 18px;
    }

    .caller-card-wrap .left-img-wrap .bottom-icon-wrap .feature-icon-wrap .icon-button img {
        width: 40px;
        height: 40px;
    }

    .interview-preparation .check-box .box-content-wrap .box-sub-title {
        padding: 6px 0px;
    }

    .caller-card-wrap .left-img-wrap .bottom-icon-wrap {
        padding: 0px 15px;
    }
}

@media (max-width: 768px) {
    .interview-preparation {
        padding: 50px 20px;
    }

    .interview-preparation .header-wrap .logo {
        margin-bottom: 0px;
    }

    .interview-preparation .header-wrap {
        display: flex;
        justify-content: space-between;
    }

    .interview-preparation .interview-details .caller-details {
        font-size: 12px;
        line-height: 20px;
        font-weight: 400;
        text-align: center;
        font-family: "Inter", sans-serif;
        flex-direction: column;
        border-bottom: none;
    }

    .interview-preparation .caller-details .dot {
        display: none;
    }

    .interview-preparation .header-wrap .title {
        margin-top: 0px;
        font-size: 14px;
    }

    .caller-card-wrap .left-img-wrap .bottom-icon-wrap .feature-icon-wrap .icon-button img {
        width: 30px;
        height: 30px;
    }

    .interview-mode-wrapper .interview-details {
        padding-top: 15px;
    }

    .interview-mode-wrap {
        padding-top: 10px;
    }

    .interview-preparation .main-content {
        flex-direction: column;
        align-items: center;
    }

    .interview-preparation .left-content,
    .interview-preparation .right-content {
        width: 100%;
    }

    .interview-preparation .start-interview-button {
        position: static;
        margin-top: 15px;
        align-self: center;
    }

    .interview-preparation .bottom-content {
        flex-direction: column;
    }

    .interview-preparation .top-content {
        display: none;
    }

    .bottom-btn-wrap {
        display: block;
    }

    .bottom-btn-wrap .start-interview-button {
        background-color: #06efc5;
        color: #000;
        font-size: 14px;
        font-weight: 800;
        line-height: 13.33px;
        padding: 18px 60px;
        border: none;
        cursor: pointer;
        font-family: "Inter", sans-serif;
        width: 100%;
    }

    .bottom-btn-wrap .start-interview-button img {
        width: 20px;
        height: 20px;
    }

    .interview-preparation .right-box-wrap {
        display: none;
    }

    .interview-preparation .mobile-accrodians {
        display: flex;
    }

    .interview-preparation .interviewAccrodian {
        gap: 18px;
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    .interview-preparation .interviewAccrodian .accordion-button {
        background: #0e1b37;
    }

    .interview-preparation .interviewAccrodian .accordion-body {
        padding-top: 10px;
        background: #0e1b37;
    }

    .interview-preparation .interviewAccrodian .box-title {
        font-size: 12px;
        font-weight: 600;
        line-height: 19px;
        letter-spacing: -0.02em;
        text-align: left;
        color: white;
    }

    .interview-preparation .interviewAccrodian .box-description {
        font-size: 12px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.02em;
        text-align: left;
    }

    .interview-preparation .interviewAccrodian .accordian-image {
        width: 16px;
        margin-right: 12px;
    }

    .interview-preparation .interviewAccrodian .accordion-button:not(.collapsed) {
        padding-bottom: 0;
    }

    .interview-preparation .interviewAccrodian .accordion-button::after {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    }

    .interview-preparation .disableButton {
        background-color: #271b3b;
        color: white;
    }

    .interview-preparation .filterInvert {
        filter: invert(1);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/InterviewPreparation/InterviewPreparation.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,WAAW;IACX,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,oBAAoB;IACpB,iDAAiD;IACjD,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,gCAAgC;IAChC,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gCAAgC;IAChC,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;;;GAGG;;AAEH;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,8BAA8B;IAClC;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;QAClB,gCAAgC;QAChC,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,gCAAgC;QAChC,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAS;QACT,aAAa;QACb,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,uBAAuB;QACvB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,yDAAqE;IACzE;;IAEA;QACI,yBAAyB;QACzB,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".interview-preparation {\n    background-color: rgba(15, 1, 37, 1);\n    color: #fff;\n    min-height: 100vh;\n    padding: 40px 100px 50px 50px;\n}\n\n.interview-preparation .interview-mode-header {\n    margin-bottom: 30px;\n    display: unset;\n    border-bottom: none;\n    background-color: transparent;\n}\n\n.interview-preparation .header-wrap .logo {\n    max-width: 100px;\n    display: block;\n    margin-bottom: 5px;\n}\n\n.interview-preparation .interview-details {\n    margin-top: 5px;\n}\n\n.interview-preparation .header-wrap .title {\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 28px;\n    text-align: left;\n    font-family: \"Inter\", sans-serif;\n}\n\n.interview-preparation .interview-details .caller-details {\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 34px;\n    font-family: \"Inter\", sans-serif;\n    padding-bottom: 16px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n    display: flex;\n}\n\n.interview-preparation .caller-details span {\n    font-weight: 600;\n}\n\n.interview-preparation .caller-details .dot {\n    display: block;\n}\n\n.interview-preparation .top-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 10px 0px;\n}\n\n.interview-preparation .status {\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 60px;\n    color: #38bbf4;\n    font-family: \"Inter\", sans-serif;\n    color: #38bbf4;\n    /* margin-bottom: 39px; */\n}\n\n.interview-preparation .warning {\n    color: #ffb800;\n}\n\n.interview-preparation .error {\n    color: #ef3f3f;\n}\n\n.interview-preparation .errorBg {\n    background: #f842421f !important;\n}\n\n.interview-preparation .start-interview-button {\n    background-color: #06efc5;\n    color: #000;\n    font-size: 18px;\n    font-weight: 800;\n    line-height: 13.33px;\n    padding: 18px 60px;\n    border: none;\n    cursor: pointer;\n    font-family: \"Inter\", sans-serif;\n    gap: 10px;\n}\n\n.interview-preparation .disableButton {\n    background-color: #271b3b;\n    color: white;\n}\n\n.interview-preparation .filterInvert {\n    filter: invert(1);\n}\n\n.interview-preparation .start-interview-button img {\n    width: 20px;\n    height: 20px;\n}\n\n.interview-preparation .bottom-content {\n    display: flex;\n    gap: 15px;\n}\n\n.interview-preparation .check-box {\n    background-color: rgba(6, 239, 197, 0.11);\n    padding: 32px 30px;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 16px;\n}\n\n.interview-preparation .check-box .box-content-wrap .box-title {\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 19px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.interview-preparation .check-box .box-content-wrap .box-sub-title {\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 37px;\n    padding: 16px 0px 10px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.interview-preparation .check-box .box-content-wrap .box-description {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    font-family: \"Inter\", sans-serif;\n}\n\n/* .interview-preparation .check-box .icon-check img {\n    width: 14px;\n    height: 14px;\n} */\n\n.interview-preparation .right-content .top-row {\n    display: flex;\n    gap: 15px;\n}\n\n.interview-preparation .right-content .bottom-row {\n    display: flex;\n    gap: 15px;\n    margin-top: 15px;\n}\n\n.bottom-btn-wrap {\n    display: none;\n}\n\n.interview-preparation .mobile-accrodians {\n    display: none;\n}\n\n@media (max-width: 1650px) {\n    .interview-preparation {\n        padding: 30px 100px 30px;\n    }\n\n    .interview-preparation .check-box {\n        padding: 15px 30px;\n    }\n\n    .caller-card-wrap .left-img-wrap .caller-img {\n        width: 400px;\n    }\n\n    .caller-card-wrap .left-img-wrap .bottom-icon-wrap .bottom-title {\n        line-height: 30px;\n        font-size: 18px;\n    }\n\n    .caller-card-wrap .left-img-wrap .bottom-icon-wrap .feature-icon-wrap .icon-button img {\n        width: 40px;\n        height: 40px;\n    }\n\n    .interview-preparation .check-box .box-content-wrap .box-sub-title {\n        padding: 6px 0px;\n    }\n\n    .caller-card-wrap .left-img-wrap .bottom-icon-wrap {\n        padding: 0px 15px;\n    }\n}\n\n@media (max-width: 768px) {\n    .interview-preparation {\n        padding: 50px 20px;\n    }\n\n    .interview-preparation .header-wrap .logo {\n        margin-bottom: 0px;\n    }\n\n    .interview-preparation .header-wrap {\n        display: flex;\n        justify-content: space-between;\n    }\n\n    .interview-preparation .interview-details .caller-details {\n        font-size: 12px;\n        line-height: 20px;\n        font-weight: 400;\n        text-align: center;\n        font-family: \"Inter\", sans-serif;\n        flex-direction: column;\n        border-bottom: none;\n    }\n\n    .interview-preparation .caller-details .dot {\n        display: none;\n    }\n\n    .interview-preparation .header-wrap .title {\n        margin-top: 0px;\n        font-size: 14px;\n    }\n\n    .caller-card-wrap .left-img-wrap .bottom-icon-wrap .feature-icon-wrap .icon-button img {\n        width: 30px;\n        height: 30px;\n    }\n\n    .interview-mode-wrapper .interview-details {\n        padding-top: 15px;\n    }\n\n    .interview-mode-wrap {\n        padding-top: 10px;\n    }\n\n    .interview-preparation .main-content {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .interview-preparation .left-content,\n    .interview-preparation .right-content {\n        width: 100%;\n    }\n\n    .interview-preparation .start-interview-button {\n        position: static;\n        margin-top: 15px;\n        align-self: center;\n    }\n\n    .interview-preparation .bottom-content {\n        flex-direction: column;\n    }\n\n    .interview-preparation .top-content {\n        display: none;\n    }\n\n    .bottom-btn-wrap {\n        display: block;\n    }\n\n    .bottom-btn-wrap .start-interview-button {\n        background-color: #06efc5;\n        color: #000;\n        font-size: 14px;\n        font-weight: 800;\n        line-height: 13.33px;\n        padding: 18px 60px;\n        border: none;\n        cursor: pointer;\n        font-family: \"Inter\", sans-serif;\n        width: 100%;\n    }\n\n    .bottom-btn-wrap .start-interview-button img {\n        width: 20px;\n        height: 20px;\n    }\n\n    .interview-preparation .right-box-wrap {\n        display: none;\n    }\n\n    .interview-preparation .mobile-accrodians {\n        display: flex;\n    }\n\n    .interview-preparation .interviewAccrodian {\n        gap: 18px;\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n    }\n\n    .interview-preparation .interviewAccrodian .accordion-button {\n        background: #0e1b37;\n    }\n\n    .interview-preparation .interviewAccrodian .accordion-body {\n        padding-top: 10px;\n        background: #0e1b37;\n    }\n\n    .interview-preparation .interviewAccrodian .box-title {\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 19px;\n        letter-spacing: -0.02em;\n        text-align: left;\n        color: white;\n    }\n\n    .interview-preparation .interviewAccrodian .box-description {\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 24px;\n        letter-spacing: -0.02em;\n        text-align: left;\n    }\n\n    .interview-preparation .interviewAccrodian .accordian-image {\n        width: 16px;\n        margin-right: 12px;\n    }\n\n    .interview-preparation .interviewAccrodian .accordion-button:not(.collapsed) {\n        padding-bottom: 0;\n    }\n\n    .interview-preparation .interviewAccrodian .accordion-button::after {\n        background-image: url(\"/public/assets/images/downAccrodianArrow.svg\");\n    }\n\n    .interview-preparation .disableButton {\n        background-color: #271b3b;\n        color: white;\n    }\n\n    .interview-preparation .filterInvert {\n        filter: invert(1);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
